import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import style from "./styles";

const box = props => {
    const styles = style();
    return (
        <Box my={props.my} className={styles[props.className]}>
            {
                props.children
            }
        </Box>
    )
}

Box.propTypes = {
    children: PropTypes.node
};

export default box